export const POSITIVE = 'POSITIVE'
export const NEUTRAL = 'NEUTRAL'
export const NEGATIVE = 'NEGATIVE'
